export const enum ProductsAiSearchDetectModalButtonSteps {
  FIRST = 'first',
  SECOND = 'second'
}
